
import React from 'react'
import { Clock, Award } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Progress } from '@/components/ui/progress'

interface ModuleHeaderProps {
  title: string
  description: string
  category: string
  coins: number
  contentLength: number
  progress: number
}

const ModuleHeader = ({ title, description, category, coins, contentLength, progress }: ModuleHeaderProps) => {
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Wealth':
        return {
          icon: 'bg-gradient-to-br from-green-400 to-green-600',
          badge: 'bg-green-100 text-green-800 border-green-200'
        }
      case 'Self':
        return {
          icon: 'bg-gradient-to-br from-blue-400 to-blue-600',
          badge: 'bg-blue-100 text-blue-800 border-blue-200'
        }
      case 'Social':
        return {
          icon: 'bg-gradient-to-br from-orange-400 to-orange-600',
          badge: 'bg-orange-100 text-orange-800 border-orange-200'
        }
      default:
        return {
          icon: 'bg-gradient-to-br from-gray-400 to-gray-600',
          badge: 'bg-gray-100 text-gray-800 border-gray-200'
        }
    }
  }

  const colors = getCategoryColor(category)

  return (
    <Card className="bg-white rounded-xl shadow-sm border border-gray-100">
      <CardContent className="p-6">
        <div className="flex items-start gap-4 mb-4">
          <div className={`w-12 h-12 ${colors.icon} rounded-xl flex items-center justify-center`}>
            <Award className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Badge className={`${colors.badge} text-xs`}>
                {category}
              </Badge>
              <Badge variant="outline" className="text-xs">Beginner</Badge>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
            <p className="text-gray-600 text-sm mb-3">{description}</p>
            
            <div className="flex items-center gap-4 text-xs text-gray-500">
              <div className="flex items-center gap-1">
                <Clock className="w-3 h-3" />
                {contentLength} lessons
              </div>
              <div className="flex items-center gap-1">
                <Award className="w-3 h-3 text-purple-600" />
                {coins} COINS
              </div>
            </div>
          </div>
        </div>

        {/* Progress */}
        <div className="mb-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Progress</span>
            <span className="text-sm text-gray-600">{progress}% complete</span>
          </div>
          <Progress value={progress} className="h-2" />
        </div>
      </CardContent>
    </Card>
  )
}

export default ModuleHeader
